import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormGroup } from '@angular/forms';
import { CardControl } from "../../models/CardControl";

@Component({
  standalone: false,
  selector: 'mm-card-component',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})

export class CardComponent implements OnInit {
    @Input() parentForm!: UntypedFormGroup;
    @Input() cardModel: CardControl;
    @Output() valueSelected: EventEmitter<string> = new EventEmitter();
    radioSelected: boolean;

    constructor() {}

    ngOnInit(): void {}

    get hasError(): boolean {
      const control = this.parentForm?.controls[`${this.cardModel?.controlName}`];
      if (control?.touched) {
        return control?.invalid ?? false
      }
      return false;
    }

    get errorText(): string {
      return this.cardModel.validationMessage;
    }
}